import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status", "icon", "message", "serverUrl"]

  connect() {
    this.checkStatus()
  }

  refresh() {
    this.checkStatus()
  }

  async checkStatus() {
    this.showLoading()

    try {
      const response = await fetch("/api/v1/triton/status", {
        method: "GET",
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      const data = await response.json()
      
      if (!data.configured) {
        this.showNotConfigured()
      } else if (data.status === "reachable") {
        this.showReachable(data.server_url)
      } else {
        this.showUnreachable(data.server_url, data.message)
      }
    } catch (error) {
      this.showError(error.message)
    }
  }

  showLoading() {
    this.statusTarget.className = "flex items-center gap-2 p-3 bg-gray-100 border border-gray-200 rounded-lg"
    this.iconTarget.innerHTML = `
      <svg class="w-4 h-4 text-gray-400 animate-spin" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
    `
    this.messageTarget.textContent = "Checking server status..."
    this.messageTarget.className = "text-xs text-gray-500"
    this.serverUrlTarget.textContent = ""
  }

  showReachable(serverUrl) {
    this.statusTarget.className = "flex items-center gap-2 p-3 bg-green-50 border border-green-200 rounded-lg"
    this.iconTarget.innerHTML = `
      <svg class="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
      </svg>
    `
    this.messageTarget.textContent = "Server is reachable"
    this.messageTarget.className = "text-xs text-green-700 font-medium"
    this.serverUrlTarget.textContent = serverUrl
    this.serverUrlTarget.className = "block text-xs text-green-600/70 font-mono"
  }

  showUnreachable(serverUrl, message) {
    this.statusTarget.className = "flex items-center gap-2 p-3 bg-red-50 border border-red-200 rounded-lg"
    this.iconTarget.innerHTML = `
      <svg class="w-4 h-4 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    `
    this.messageTarget.textContent = message || "Server is not reachable"
    this.messageTarget.className = "text-xs text-red-700 font-medium"
    this.serverUrlTarget.textContent = serverUrl
    this.serverUrlTarget.className = "block text-xs text-red-600/70 font-mono"
  }

  showNotConfigured() {
    this.statusTarget.className = "flex items-center gap-2 p-3 bg-amber-50 border border-amber-200 rounded-lg"
    this.iconTarget.innerHTML = `
      <svg class="w-4 h-4 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
      </svg>
    `
    this.messageTarget.textContent = "Set TRITON_SERVER_URL environment variable"
    this.messageTarget.className = "text-xs text-amber-700 font-medium"
    this.serverUrlTarget.textContent = ""
  }

  showError(message) {
    this.statusTarget.className = "flex items-center gap-2 p-3 bg-gray-100 border border-gray-200 rounded-lg"
    this.iconTarget.innerHTML = `
      <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
      </svg>
    `
    this.messageTarget.textContent = `Error: ${message}`
    this.messageTarget.className = "text-xs text-gray-500"
    this.serverUrlTarget.textContent = ""
  }
}
